import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0D3A7E',
        secondary: '#6F6E73',
        secondaryButton: '#FA6B17',
        backgroundCard: '#EBEBEB',
        accent: '#8c9eff',
        error: '#b71c1c',
        wall: '#FAFAFA',
        card: '#e6e6e6',
        blueCard: '#CED1E0',
        white: '#FFFFFF',
        footer: '#F5F5F5'
      },
    },
  },
  icons: {
    iconfont: 'md'
  }
}

export default new Vuetify(opts);